<template>
  <page>
    <rest-page-error :error="error" />
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import RestPageError from '@/common/components/rest/RestPageError'

export default {
  name: 'RestErrorPage',
  components: { RestPageError, Page },
  computed: {
    error() {
      return this.$route.params[1]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/errors/pages/RestErrorPage.vue